import styled from "styled-components";

export const StyledPortalHeader = styled.div`
  align-items: center;
  background: var(--CLOUD, #fcfdfe);
  border-bottom: 1px solid var(--Color-Tokens-Border-Primary, #e4e4e4);
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  font-weight: 600;
  gap: 16px;
  height: 72px;
  justify-content: space-between;
  line-height: 24px;
  min-height: 72px;
  padding: 0 24px;
`;

/** Ant Design drawer header shell — use with PortalHeader as title and header padding 0. */
export const portalDrawerAntHeaderCss = `
  border-bottom: 0;
  flex-shrink: 0;
  height: 72px;
  min-height: 72px;
  padding: 0;
`;

export const PortalHeaderContent = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  min-width: 0;
`;

export const PortalHeaderActions = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 16px;
  margin-left: auto;
`;
